import { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Container } from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
import LogoHeader from "../Assets/Image/logo-1.jpeg";
import "../Assets/Css/webheader.css";
import { FaHome, FaIndustry, FaTools } from "react-icons/fa";
import { MdEngineering, MdContacts } from "react-icons/md";
import { GiFactory } from "react-icons/gi";
import { FaCubes } from "react-icons/fa";
import { TbReportAnalytics } from "react-icons/tb";

import { FaCertificate, FaPhoneAlt, FaEnvelope } from "react-icons/fa";
function WebHeader() {
  const [showSidebar, setShowSidebar] = useState(false);
  const [navbarSolid, setNavbarSolid] = useState(false);

  const handleClose = () => setShowSidebar(false);
  const handleShow = () => setShowSidebar(true);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const isMobile = window.innerWidth <= 768;
      const bannerHeight = isMobile
        ? 0.7 * window.innerHeight
        : window.innerHeight;

      setNavbarSolid(scrollTop > bannerHeight - 200);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navigate = useNavigate();

  return (
    <>
      <div className="top-info-bar  bg-white text-black border-bottom">
        <Container fluid className="px-0">
          <div
            className="d-flex align-items-center justify-content-center justify-content-lg-end gap-1 top-info-text text-center text-lg-end px-2 py-2"
            style={{
              whiteSpace: "nowrap",
              overflowX: "auto",
              WebkitOverflowScrolling: "touch",
              fontSize: "12px",
            }}
          >
            <div className="d-flex align-items-center gap-2 flex-shrink-0 clickable-text">
              <FaPhoneAlt style={{ color: "#ffffffff" }} />
              <a
                href="tel:+919021399351"
                style={{
                  fontSize: "14px",
                  textDecoration: "none",
                  color: "inherit",
                }}
              >
                +91 9021399351
              </a>
            </div>
            <div className="d-flex align-items-center gap-2 flex-shrink-0 clickable-text">
              <FaEnvelope style={{ color: "#ffffffff" }} />
              <a
                href="mailto:info@deltaen.in"
                style={{
                  fontSize: "14px",
                  textDecoration: "none",
                  color: "inherit",
                }}
              >
                info@deltaen.in
              </a>
            </div>
            <div className="align-items-center gap-3 flex-shrink-0">
              <span className="clickable-text">
                ISO 9001:2015 Certified Company
              </span>
            </div>
          </div>
        </Container>
      </div>
      <Navbar
        expand="lg"
        className={`custom-navbar ${
          navbarSolid ? "navbar-solid" : "navbar-transparent"
        }`}
      >
        <Container
          fluid
          className="d-flex justify-content-between align-items-center px-3 px-lg-5"
        >
          <Navbar.Brand href="/" className="d-flex align-items-center p-0 m-0">
            <span onClick={() => navigate("/")} style={{ cursor: "pointer" }}>
              <img
                src={LogoHeader}
                alt="Logo"
                className={`navbar-logo ${navbarSolid ? "scrolled" : ""}`}
                loading="lazy"
              />
            </span>
          </Navbar.Brand>

          {/* Mobile toggle */}
          <Navbar.Toggle
            aria-controls="offcanvasNavbar"
            onClick={handleShow}
            className="d-lg-none"
          />

          {/* Desktop menu */}
          <Navbar.Collapse
            id="basic-navbar-nav"
            className="justify-content-center d-none d-lg-flex"
          >
            <Nav>
              <Nav.Link
                as={NavLink}
                to="/"
                onClick={handleClose}
                className="nav-spacing"
              >
                Home
              </Nav.Link>
              <Nav.Link
                as={NavLink}
                to="/about"
                onClick={handleClose}
                className="nav-spacing"
              >
                About Us
              </Nav.Link>
              <Nav.Link
                as={NavLink}
                to="/facilities"
                onClick={handleClose}
                className="nav-spacing"
              >
                Facilities
              </Nav.Link>
              <Nav.Link
                as={NavLink}
                to="/ourproducts"
                onClick={handleClose}
                className="nav-spacing"
              >
                Products
              </Nav.Link>
              <Nav.Link
                as={NavLink}
                to="/data"
                onClick={handleClose}
                className="nav-spacing"
              >
                Products Data
              </Nav.Link>
              <Nav.Link
                as={NavLink}
                to="/contact"
                onClick={handleClose}
                className="nav-spacing"
              >
                Contact Us
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Offcanvas for mobile */}
      <Offcanvas
        show={showSidebar}
        onHide={handleClose}
        placement="start"
        className="custom-offcanvas"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <img
              src={LogoHeader}
              alt="Logo"
              className="navbar-logo"
              loading="lazy"
            />
          </Offcanvas.Title>
        </Offcanvas.Header>
        {/* <Offcanvas.Body className="offcanvasbody">
          <Nav className="flex-column">
            <Nav.Link as={NavLink} to="/" onClick={handleClose}>
              <FaHome size={18} className="me-2" /> Home
            </Nav.Link>
            <Nav.Link as={NavLink} to="/about" onClick={handleClose}>
              <FaBuilding size={18} className="me-2" /> About Us
            </Nav.Link>
            <Nav.Link as={NavLink} to="/facilities" onClick={handleClose}>
              <FaRocket size={18} className="me-2" /> Facilities
            </Nav.Link>
            <Nav.Link as={NavLink} to="/ourproducts" onClick={handleClose}>
              <FaLaptopCode size={18} className="me-2" /> Products
            </Nav.Link>
            <Nav.Link as={NavLink} to="/data" onClick={handleClose}>
              <FaShoppingCart size={18} className="me-2" /> Products Data
            </Nav.Link>
            <Nav.Link as={NavLink} to="/contact" onClick={handleClose}>
              <FaEnvelopeOpenText size={18} className="me-2" /> Contact Us
            </Nav.Link>
          </Nav>
        </Offcanvas.Body> */}

<Offcanvas.Body className="offcanvasbody">
  <Nav className="flex-column">
    <Nav.Link as={NavLink} to="/" onClick={handleClose}>
      <FaHome size={18} className="me-2" /> Home
    </Nav.Link>

    <Nav.Link as={NavLink} to="/about" onClick={handleClose}>
      <MdEngineering size={18} className="me-2" /> About Us
    </Nav.Link>

    <Nav.Link as={NavLink} to="/facilities" onClick={handleClose}>
      <GiFactory size={18} className="me-2" /> Facilities
    </Nav.Link>
<Nav.Link as={NavLink} to="/ourproducts" onClick={handleClose}>
  <FaCubes size={18} className="me-2" /> Products
</Nav.Link>

    <Nav.Link as={NavLink} to="/data" onClick={handleClose}>
      <TbReportAnalytics size={18} className="me-2" /> Products Data
    </Nav.Link>

    <Nav.Link as={NavLink} to="/contact" onClick={handleClose}>
      <MdContacts size={18} className="me-2" /> Contact Us
    </Nav.Link>
  </Nav>
</Offcanvas.Body>

      </Offcanvas>
    </>
  );
}

export default WebHeader;
